/* Podcast Player */
export enum enumPlayState {
    PLAYING = "playing",
    PAUSED = "paused",
    LOADING = "loading"
}

/* Utils */
export enum enumDisplay {
    SHOW = 'block',
    HIDE = 'none'
}

/* Book Formats */
export enum enumBookType {
    PAPERBACK = 'Paperback',
    HARDCOVER = 'Hardcover',
    EBOOK = 'eBook',
    AUDIO = 'Audiobook'
}